import { OptionItem } from "../typing";

/**
 * 获取多选项选中值的展示文案
 * @param options
 * @param values
 * @returns
 */
export const getOptionCheckedText = (options: OptionItem[], values: string[]) => {
  const existValues = values.filter((value) => options.find((option) => option.value === value));

  const target = options.find((item) => item.value === existValues[0]);
  if (target) {
    let result = target.label;
    if (existValues.length > 1) {
      result += ` +${existValues.length - 1}`;
    }
    return result;
  }
  return "";
};

/**
 * 获取单选项选中值的展示文案
 * @param options
 * @param values
 * @returns
 */
export const getRadioCheckedText = (options: OptionItem[], value: string) => {
  const target = options.find((item) => item.value === value);
  if (target) {
    return target.label;
  }
  return "";
};
